import React from "react";

const HeaderNotificationIcon = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3399 12.8284C18.1299 12.4584 17.9399 11.7584 17.9399 11.3484V8.81844C17.9399 5.55844 15.2899 2.89844 12.0199 2.89844C8.74994 2.89844 6.09994 5.55844 6.09994 8.81844V11.3484C6.09994 11.7584 5.90994 12.4584 5.69994 12.8184L4.68994 14.4884C4.28994 15.1584 4.19994 15.8984 4.44994 16.5784C4.68994 17.2484 5.25994 17.7684 5.99994 18.0184C7.93994 18.6784 9.97994 18.9984 12.0199 18.9984C14.0599 18.9984 16.0999 18.6784 18.0399 18.0284C18.7399 17.7984 19.2799 17.2684 19.5399 16.5784C19.7999 15.8884 19.7299 15.1284 19.3399 14.4884L18.3399 12.8284Z"
        fill="#3D68FF"
      />
      <path
        d="M12.0208 2.9C11.2408 2.9 10.4908 3.04 9.80078 3.32C10.2308 2.51 11.0808 2 12.0208 2C12.9708 2 13.8108 2.51 14.2508 3.32C13.5608 3.05 12.8108 2.9 12.0208 2.9Z"
        fill="#3055D4"
      />
      <path
        d="M11.9997 22C11.2097 22 10.4297 21.68 9.87969 21.11C9.55969 20.81 9.31969 20.41 9.17969 20C9.30969 20.02 9.43969 20.03 9.57969 20.05C9.80969 20.08 10.0497 20.11 10.2897 20.13C10.8597 20.18 11.4397 20.21 12.0197 20.21C12.5897 20.21 13.1597 20.18 13.7197 20.13C13.9297 20.11 14.1397 20.1 14.3397 20.07C14.4997 20.05 14.6597 20.03 14.8297 20.01C14.4097 21.17 13.2997 22 11.9997 22Z"
        fill="#3055D4"
      />
    </svg>
  );
};

export default HeaderNotificationIcon;
